<!-- use case

import EmPopoverShow from "@/components/EmPopoverShow";

<EmPopoverShow
  :id="'emPopoverShow-'+row.item.id"
  v-if="row.item.催办"
  v-bind:popoverDatas="row.item.催办"
  buttonName="btn.basic.haveUrged"
  variant="warning"
  title="btn.basic.urged"
></EmPopoverShow>
-->

<template>
  <div :id="id">
    <div>
      <!-- Our triggering (target) element -->
      <b-button
        size="sm"
        :id="btnId"
        :disabled="popoverShow"
        :variant="variant"
        ref="button"
      >{{$t(buttonName)}}</b-button>
    </div>

    <!-- Our popover title and content render container -->
    <!-- We use placement 'auto' so popover fits in the best spot on viewport -->
    <!-- We specify the same container as the trigger button, so that popover is close to button -->
    <b-popover
      :target="btnId"
      triggers="hover"
      placement="bottomleft"
      container="myContainer"
      ref="popover"
      style="max-width:10rem;"
    >
      <template slot="title">
        <b-button @click="onClose" class="close" aria-label="Close">
          <span class="d-inline-block" aria-hidden="true">&times;</span>
        </b-button>
        {{$t(title)}}
      </template>

      <div style="width:12rem;">
        <b-alert show class="small" v-for="data in popoverDatas" :key="data.id">
          <div v-for="(value, key) in data" :key="key">
            <strong>{{ key }} : {{ value }}</strong>
          </div>
        </b-alert>
      </div>
    </b-popover>
  </div>
</template>

<script>
export default {
  name: "emPopoverShow",
  props: {
    id: {
      type: String,
      required: true
    },
    popoverDatas: {
      type: Object,
      required: true
    },
    buttonName: {
      type: String,
      default: "详情"
    },
    variant: {
      type: String,
      default: "primary"
    },
    title: {
      type: String,
      default: "详情"
    }
  },
  data() {
    return {
      input1: "",
      input1state: null,
      input2: "",
      input2state: null,
      options: [{ text: "- Choose 1 -", value: "" }, "Red", "Green", "Blue"],
      input1Return: "",
      input2Return: "",
      popoverShow: false
    };
  },
  computed: {
    // 计算属性的 getter
    btnId: function() {
      // `this` 指向 vm 实例
      return this.id + "-btn";
    }
  },
  watch: {
    input1(val) {
      if (val) {
        this.input1state = true;
      }
    },
    input2(val) {
      if (val) {
        this.input2state = true;
      }
    }
  },
  methods: {
    onClose() {
      this.popoverShow = false;
    },
    onOk() {
      if (!this.input1) {
        this.input1state = false;
      }
      if (!this.input2) {
        this.input2state = false;
      }
      if (this.input1 && this.input2) {
        this.onClose();
        // Return our popover form results
        this.input1Return = this.input1;
        this.input2Return = this.input2;
      }
    },
    onShow() {
      // This is called just before the popover is shown
      // Reset our popover form variables
      this.input1 = "";
      this.input2 = "";
      this.input1state = null;
      this.input2state = null;
      this.input1Return = "";
      this.input2Return = "";
    },
    onShown() {
      // Called just after the popover has been shown
      // Transfer focus to the first input
      this.focusRef(this.$refs.input1);
    },
    onHidden() {
      // Called just after the popover has finished hiding
      // Bring focus back to the button
      this.focusRef(this.$refs.button);
    },
    focusRef(ref) {
      // Some references may be a component, functional component, or plain element
      // This handles that check before focusing, assuming a `focus()` method exists
      // We do this in a double `$nextTick()` to ensure components have
      // updated & popover positioned first
      this.$nextTick(() => {
        this.$nextTick(() => {
          (ref.$el || ref).focus();
        });
      });
    }
  }
};
</script>